import React from 'react';
import axios from 'axios';

import Loading from '.././Loading';

import {
  CSRF_TOKEN,
  metaLoading,
} from '../../lib/helpers';
import { get } from 'lodash';
import NumberInput from '../settings/NumberInput';

class IntegrationControl extends React.Component {
  state = {
    ...metaLoading,
    integration_id: null
  }

  componentDidMount() {
    this.setState({ meta: { isLoading: true } }, this.loadIntegration)
  }

  loadIntegration() {
    axios.get(this.props.path)
      .then((res) => {
        const integration_id = get(res, 'data.integration_id')
        if(res.status == 200) {
          this.setState({ integration_id: integration_id, meta: { isLoading: false } })
        }
      })
  }

  updateIntegration(integration_id) {
    axios.put(this.props.path, { authenticity_token: CSRF_TOKEN, integration_id: integration_id })
      .then(() => this.setState({ integration_id: integration_id }))
      .then(() => this.props.onSubmit())
  }

  removeIntegration() {
    axios.delete(this.props.path, { data: { authenticity_token: CSRF_TOKEN } })
      .then(() => this.setState({ integration_id: null }))
      .then(() => this.props.onSubmit())
  }

  render = () => {
    const { integration_id } = this.state
    const isLoading = get(this.state, 'meta.isLoading')
    return (
      <Loading isLoading={isLoading}>
        <div>
          <h4>{this.props.integrationName} Id</h4>
          <NumberInput
            param='integration_id'
            value={integration_id}
            reset={!integration_id}
            updateHandler={(_key, val) => this.updateIntegration(val)}
          >
            <button
              type='button'
              disabled={!integration_id}
              className='Button Button--icon-remove'
              onClick={() => this.removeIntegration()}
            />
          </NumberInput>
        </div>
      </Loading>
    )
  }
}

export default IntegrationControl;
